import { Component, OnInit } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
// import VanillaTilt, { TiltOptions } from 'vanilla-tilt';
// import { LoaderComponent } from 'src/app/helpers/loader/loader.component';
import { AppComponent } from 'src/app/app.component';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-manager-registration',
  templateUrl: './manager-registration.component.html',
  styleUrls: ['./manager-registration.component.css']
})
export class ManagerRegistrationComponent {

  c_p_hide: boolean = true;
  p_hide: boolean = true;
  FirstName = new FormControl('', [
    Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/)
  ]);
  LastName = new FormControl('', [
    Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/)
  ]);
  Email = new FormControl('', [
    Validators.required, Validators.email
  ]);
  Password = new FormControl('', [
    Validators.required, Validators.pattern(/^.{5}/)
  ]);
  ConfirmPassword = new FormControl('', [
    Validators.required, Validators.pattern(/^.{5}/)
  ]);
  MobileNumber = new FormControl('', [
    Validators.required, Validators.pattern(/^[0-9]{10}$/)
  ]);
  ReferredBy = new FormControl('', [
    Validators.required, Validators.pattern(/^[0-9]{10}$/)
  ]);
  getEmailError() {
    if (this.Email.hasError('required')) {
      return 'Email is required.';
    }
    else if (this.Email.hasError('email')) {
      return 'Please enter a valid email address.';
    }
    else {
      return '';
    }

  }
  getFirstNameError() {
    if (this.FirstName.hasError('required')) {
      return 'FirstName is required.';
    }
    else if (this.FirstName.hasError('pattern')) {
      return 'Please enter a valid First Name';
    }
    else {
      return '';
    }

  }
  getLastNameError() {
    if (this.LastName.hasError('required')) {
      return 'LastName is required.';
    }
    else if (this.LastName.hasError('pattern')) {
      return 'Please enter a valid Last Name';
    }
    else {
      return '';
    }

  }

  getMobileNumberError() {
    if (this.MobileNumber.hasError('required')) {
      return 'Mobile Number is required.';
    }
    else if (this.MobileNumber.hasError('pattern')) {
      return 'Please enter Mobile Number in 10 digits';
    }
    else {
      return '';
    }

  }


  getPasswordError() {
    if (this.Password.hasError('required')) {
      return 'Password is required.';
    }
    else if (this.Password.hasError('pattern')) {
      return 'Please enter a password more than 5 letters';
    }
    else {
      return '';
    }

  }
  getConfirmPasswordError() {
    if (this.ConfirmPassword.hasError('required')) {
      return 'Confirm Password is required.';
    }
    else if (this.ConfirmPassword.hasError('pattern')) {
      return 'Please enter Confirm password more than 5 letters';
    }
    else {
      return '';
    }
  }


  



  constructor(public service: SharkifyAiSerivceService, public router: Router,
    public app: AppComponent, private toastr: ToastrService) {
  }
  ngOnInit(): void {
  }
  onManagerSubmit() {
    this.app.displayLoader(true);
    if (this.MobileNumber.valid && this.Email.valid && this.FirstName.valid && this.LastName.valid && this.Password.valid && this.ConfirmPassword.valid) {
      if (this.Password.value == this.ConfirmPassword.value) {
        this.service.AccountManagerRegistration(this.FirstName.value + "", this.LastName.value + "", this.MobileNumber.value + "", this.Email.value + "", this.Password.value + "").subscribe(data => {
          this.app.displayLoader(false);
          if (data.Code === 200) {
            this.toastr.success('Manager Sign up successful!', 'Success');
            this.router.navigate(["/ManagerLogin"]);
          } else {
            this.toastr.error('Manager Sign up failed. Please try again.', 'Error');
          }
        }, error => {
          this.app.displayLoader(false);
          this.toastr.error('An error occurred. Please try again.', 'Error');
        });
      } else {
        this.toastr.error('Passwords do not match.', 'Error');
        this.app.displayLoader(false);
      }
    } else {
      this.toastr.error('Please fill in all required fields correctly.', 'Error');
      this.app.displayLoader(false);
    }
  }

}
